import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function InfoAwards() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Conference info"
        title="Awards"
        intro="At EAC2027, awards recognizing excellence in aerosol research, outstanding young researchers, and best poster presentations will be granted."
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className='h1'>The European Aerosol Assembly Award</h2>
                <p className="info-meta">
                  Granted by the European Aerosol Assembly
                </p>

                <p>
                  The <a href="https://www.info.gaef.de/eaa-award" target='_blank' rel="noreferrer">European Aerosol Assembly Award</a> is intended to recognise individuals who have contributed
                  substantially to aerosol research. These can be individuals who have distinguished themselves by
                  excellence in science, research, and leadership in the field of aerosol science and technology,
                  and/or individuals who have advanced aerosol research by promoting the EAA mission and strengthening
                  cross-society collaboration.
                </p>

                <div className="info-note">
                  <p>
                    <strong>Nomination deadline:</strong> TBD
                  </p>
                </div>

                <h3>EAA Award committee</h3>
                <ul className="info-list">
                  <li>Roberta Vecchi, chair</li>
                  <li>Amanda Lea-Langton</li>
                  <li>Jean-Pascal Borra</li>
                  <li>Miikka Dal Maso</li>
                  <li>Ulas Im</li>
                </ul>
              </section>

              <section className="info-section">
                <h2 className='h1'>Smoluchowski Award</h2>
                <p className="info-meta">
                  Granted by the Gesellschaft für Aerosolforschung (GAeF)
                </p>

                <p>
                  The <a href="https://www.info.gaef.de/smoluchowski-award" target='_blank' rel="noreferrer">Smoluchowski Award</a>, named after the physicist Marian Smoluchowski (1872–1917), recognizes
                  significant research contributions to all fields of aerosol science and technology, except for those
                  fields covered by the <a href="https://www.info.gaef.de/schmauss-award" target='_blank' rel="noreferrer">Schmauss Award</a>. The Smoluchowski and Schmauss Awards are presented alternately
                  each year.
                </p>

                <p>
                  The award is given to young researchers, defined by the year of PhD plus 10 years.
                </p>

                <div className="info-note">
                  <p>
                    <strong>Nomination deadline:</strong> TBD
                  </p>
                </div>

                  <h3>Smoluchowski Award committee</h3>
                  TBD
              </section>

              <section className="info-section">
                <h2 className='h1'>Best Poster Awards</h2>
                <p className="info-meta">
                  Granted by the European Aerosol Assembly Working Groups
                </p>

                <p>
                  The Best Poster Awards recognize outstanding poster presentations by Master’s and PhD students,
                  as well as early-career postdoctoral researchers within three years of graduation.
                </p>

                <div className="info-note">
                  <p>
                    <strong>How to apply:</strong> TBD
                  </p>
                </div>

                  <h3>Chair of the Best Poster Award</h3>
                  TBD
                
                
              </section>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}